/* GERADO POR scripts/gen-skills.ts — NÃO EDITAR À MÃO. */
/* Fonte: C:/Users/Pedro/OneDrive/Documentos/Códigos Python VSCode/_habilidades_extraidas.json */

import type { SkillMeta } from './taxonomy.ts';

/** Os 93 códigos da Matriz de Referência CAEd — Matemática, EM. */
export type MatrixSkill =
  | 'H1.1'
  | 'H1.2'
  | 'H1.3'
  | 'H1.4'
  | 'H1.5'
  | 'H1.6'
  | 'H1.7'
  | 'H1.8'
  | 'H1.9'
  | 'H1.10'
  | 'H1.11'
  | 'H1.12'
  | 'H1.13'
  | 'H1.14'
  | 'H1.15'
  | 'H1.16'
  | 'H1.17'
  | 'H1.18'
  | 'H1.19'
  | 'H1.20'
  | 'H1.21'
  | 'H1.22'
  | 'H1.23'
  | 'H1.24'
  | 'H1.25'
  | 'H1.26'
  | 'H1.27'
  | 'H1.28'
  | 'H1.29'
  | 'H1.30'
  | 'H1.31'
  | 'H1.32'
  | 'H1.33'
  | 'H1.34'
  | 'H1.35'
  | 'H1.36'
  | 'H1.37'
  | 'H2.1'
  | 'H2.2'
  | 'H2.3'
  | 'H2.4'
  | 'H2.5'
  | 'H2.6'
  | 'H2.7'
  | 'H2.8'
  | 'H2.9'
  | 'H2.10'
  | 'H2.11'
  | 'H2.12'
  | 'H2.13'
  | 'H2.14'
  | 'H2.15'
  | 'H2.16'
  | 'H2.17'
  | 'H2.18'
  | 'H2.19'
  | 'H2.20'
  | 'H2.21'
  | 'H2.22'
  | 'H2.23'
  | 'H3.1'
  | 'H3.2'
  | 'H3.3'
  | 'H3.4'
  | 'H3.5'
  | 'H3.6'
  | 'H3.7'
  | 'H3.8'
  | 'H3.9'
  | 'H3.10'
  | 'H3.11'
  | 'H3.12'
  | 'H3.13'
  | 'H3.14'
  | 'H3.15'
  | 'H3.16'
  | 'H3.17'
  | 'H3.18'
  | 'H3.19'
  | 'H3.20'
  | 'H3.21'
  | 'H3.22'
  | 'H3.23'
  | 'H3.24'
  | 'H3.25'
  | 'H3.26'
  | 'H3.27'
  | 'H3.28'
  | 'H3.29'
  | 'H3.30'
  | 'H3.31'
  | 'H3.32'
  | 'H3.33';

export const SKILLS: Readonly<Record<MatrixSkill, SkillMeta>> = Object.freeze({
  'H1.1': {
    codigo: 'H1.1' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao: 'Corresponder diferentes representações de um número real em uma situação-problema.',
  },
  'H1.2': {
    codigo: 'H1.2' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Aproximar',
    descricao: 'Aproximar números reais em uma situação-problema.',
  },
  'H1.3': {
    codigo: 'H1.3' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar números reais em seus diferentes significados, formas de representação e/ou suas operações na resolução de uma situação-problema.',
  },
  'H1.4': {
    codigo: 'H1.4' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao: 'Utilizar o conceito de porcentagem na resolução de uma situação-problema.',
  },
  'H1.5': {
    codigo: 'H1.5' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Estimar',
    descricao:
      'Estimar soluções numéricas de uma situação-problema, cujos dados tenham sido fornecidos em termos aproximados ou estejam sujeitos a margens de erro/variação.',
  },
  'H1.6': {
    codigo: 'H1.6' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar a correção de um procedimento e/ou de uma potencial solução de uma situação-problema, a partir das operações entre números reais, seus conceitos e/ou propriedades.',
  },
  'H1.7': {
    codigo: 'H1.7' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Representar',
    descricao:
      'Representar algebricamente relações de dependência entre variáveis numéricas, descritas textualmente em uma situação-problema, por meio de equações ou inequações de 1º/2º grau ou de sistemas de equações lineares com duas incógnitas.',
  },
  'H1.8': {
    codigo: 'H1.8' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder diferentes representações de relações de dependência entre variáveis numéricas em uma situação-problema, modeláveis por funções polinomiais de 1º/2º grau, exponenciais, logarítmicas e/ou definidas por várias sentenças.',
  },
  'H1.9': {
    codigo: 'H1.9' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Inferir',
    descricao:
      'Inferir o padrão de evolução de sequências numéricas e/ou figurais em uma situação problema.',
  },
  'H1.10': {
    codigo: 'H1.10' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar expressões algébricas, equações/inequações de 1º/2º grau ou sistemas de equações lineares com duas incógnitas na resolução de uma situação-problema.',
  },
  'H1.11': {
    codigo: 'H1.11' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o conceito de função polinomial de 1º/2º grau, exponencial, logarítmica ou definida por várias sentenças, suas diferentes formas de representação e/ou suas propriedades variacionais na resolução de uma situação-problema.',
  },
  'H1.12': {
    codigo: 'H1.12' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar diferentes tipos de progressões numéricas e/ou suas propriedades algébricas na resolução de uma situação-problema.',
  },
  'H1.13': {
    codigo: 'H1.13' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar características de uma situação-problema, a partir de propriedades da função polinomial de 1º/2º grau, exponencial, logarítmica ou definida por várias sentenças que a modela.',
  },
  'H1.14': {
    codigo: 'H1.14' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar parâmetros da função polinomial de 1º/2º grau, exponencial, logarítmica ou definida por várias sentenças que modela uma situação-problema, a fim de que esta assuma características pré-determinadas.',
  },
  'H1.15': {
    codigo: 'H1.15' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Relacionar',
    descricao:
      'Relacionar elementos de triângulos, quadriláteros e/ou círculos em uma situação-problema, a partir de suas propriedades geométricas.',
  },
  'H1.16': {
    codigo: 'H1.16' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Relacionar',
    descricao:
      'Relacionar elementos de prismas e/ou cilindros em uma situação-problema, a partir de suas propriedades geométricas.',
  },
  'H1.17': {
    codigo: 'H1.17' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder prismas e/ou cilindros a suas planificações ou vistas em uma situação-problema.',
  },
  'H1.18': {
    codigo: 'H1.18' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar propriedades geométricas de triângulos, quadriláteros e/ou círculos na resolução de uma situação-problema.',
  },
  'H1.19': {
    codigo: 'H1.19' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar propriedades geométricas de prismas e/ou cilindros, suas planificações ou vistas na resolução de uma situação-problema.',
  },
  'H1.20': {
    codigo: 'H1.20' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar características de uma situação-problema, a partir das propriedades geométricas de triângulos, quadriláteros, círculos, prismas e/ou cilindros nela presentes.',
  },
  'H1.21': {
    codigo: 'H1.21' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Identificar',
    descricao: 'Identificar grandezas e/ou unidades de medida em uma situação-problema.',
  },
  'H1.22': {
    codigo: 'H1.22' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar relações métricas e/ou de semelhança geométrica entre figuras planas na resolução de uma situação-problema.',
  },
  'H1.23': {
    codigo: 'H1.23' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar as razões trigonométricas seno, cosseno e/ou tangente na resolução de uma situação-problema.',
  },
  'H1.24': {
    codigo: 'H1.24' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar relações entre grandezas e/ou suas unidades de medida na resolução de uma situação-problema.',
  },
  'H1.25': {
    codigo: 'H1.25' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar conceitos e/ou medidas de área/perímetro de triângulos, quadriláteros e/ou círculos, e/ou de capacidade/volume de prismas e/ou cilindros, na resolução de uma situação-problema.',
  },
  'H1.26': {
    codigo: 'H1.26' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar a adequação da utilização de uma unidade de medida em uma situação-problema.',
  },
  'H1.27': {
    codigo: 'H1.27' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar características de uma situação-problema, a partir de relações entre grandezas nela presentes.',
  },
  'H1.28': {
    codigo: 'H1.28' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Comparar',
    descricao:
      'Comparar probabilidades de ocorrência de eventos simples associados a experimentos aleatórios, em espaços amostrais discretos e equiprováveis, em uma situação-problema.',
  },
  'H1.29': {
    codigo: 'H1.29' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o Princípio Aditivo e/ou o Princípio Multiplicativo na contagem de pareamentos distintos na resolução de uma situação-problema.',
  },
  'H1.30': {
    codigo: 'H1.30' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o conceito de probabilidade de ocorrência de um evento simples associado a um experimento aleatório, em um espaço amostral discreto e equiprovável, na resolução de uma situação-problema.',
  },
  'H1.31': {
    codigo: 'H1.31' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar propostas, interpretações ou decisões baseadas na probabilidade de ocorrência de um evento simples associado a um experimento aleatório, em um espaço amostral discreto e equiprovável, em uma situação-problema.',
  },
  'H1.32': {
    codigo: 'H1.32' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar parâmetros de uma situação-problema, de modo a tornar a ocorrência de um evento simples associado a um experimento aleatório, em um espaço amostral discreto e equiprovável, mais, menos ou igualmente provável.',
  },
  'H1.33': {
    codigo: 'H1.33' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Identificar',
    descricao:
      'Identificar dados apresentados em quadros/tabelas, gráficos estatísticos e/ou infográficos em uma situação-problema.',
  },
  'H1.34': {
    codigo: 'H1.34' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Interpretar',
    descricao:
      'Interpretar dados apresentados em quadros/tabelas, gráficos estatísticos e/ou infográficos em uma situação-problema.',
  },
  'H1.35': {
    codigo: 'H1.35' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar dados apresentados em quadros/tabelas, gráficos estatísticos e/ou infográficos na resolução de uma situação-problema.',
  },
  'H1.36': {
    codigo: 'H1.36' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar conceitos/medidas de tendência central e/ou de amplitude de um conjunto de dados na resolução de uma situação-problema.',
  },
  'H1.37': {
    codigo: 'H1.37' as SkillMeta['codigo'],
    ano: 1 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar conclusões, interpretações ou comunicações mediadas por dados apresentados em quadros/tabelas, gráficos estatísticos e/ou infográficos em uma situação-problema.',
  },
  'H2.1': {
    codigo: 'H2.1' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Representar',
    descricao:
      'Representar processos combinatórios de contagem associados a uma situação-problema em diferentes suportes.',
  },
  'H2.2': {
    codigo: 'H2.2' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder elementos numéricos de uma matriz a suas respectivas linhas e colunas em uma situação-problema (*).',
  },
  'H2.3': {
    codigo: 'H2.3' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao: 'Utilizar conceitos/operações matriciais na resolução de uma situação-problema (*).',
  },
  'H2.4': {
    codigo: 'H2.4' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o(s) modo(s) de incidência percentual simples e/ou composto na resolução de uma situação-problema financeira em contexto individual, familiar ou social.',
  },
  'H2.5': {
    codigo: 'H2.5' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar propostas e/ou comunicações realizadas em uma situação-problema financeira em contexto individual, familiar ou social, a partir de operações/conceitos numéricos.',
  },
  'H2.6': {
    codigo: 'H2.6' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder diferentes representações de relações entre variáveis numéricas em uma situação-problema, modeláveis por um sistema de equações lineares.',
  },
  'H2.7': {
    codigo: 'H2.7' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Representar',
    descricao:
      'Representar relações entre variáveis numéricas em uma situação-problema financeira, por meio de equações algébricas e/ou funções.',
  },
  'H2.8': {
    codigo: 'H2.8' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o conceito de sistema de equações lineares e/ou suas técnicas de resolução em uma situação-problema.',
  },
  'H2.9': {
    codigo: 'H2.9' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o conceito de função, suas diferentes formas de representação e/ou suas propriedades variacionais na resolução de uma situação-problema financeira em contexto individual, familiar ou social.',
  },
  'H2.10': {
    codigo: 'H2.10' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar características de uma situação-problema, a partir de propriedades do sistema de equações lineares que a modela.',
  },
  'H2.11': {
    codigo: 'H2.11' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar propostas e/ou decisões em uma situação-problema financeira em contexto individual, familiar ou social, a partir de procedimentos e/ou conceitos algébrico-funcionais.',
  },
  'H2.12': {
    codigo: 'H2.12' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Relacionar',
    descricao:
      'Relacionar elementos de polígonos, círculos e/ou suas partes em uma situação-problema, a partir de suas propriedades geométricas.',
  },
  'H2.13': {
    codigo: 'H2.13' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar propriedades geométricas de polígonos, círculos e/ou suas partes na resolução de uma situação-problema.',
  },
  'H2.14': {
    codigo: 'H2.14' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar características de uma situação-problema, a partir de propriedades geométricas de polígonos, círculos e/ou suas partes.',
  },
  'H2.15': {
    codigo: 'H2.15' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar a viabilidade da pavimentação, ladrilhamento e/ou decomposição do plano por meio de figuras planas em uma situação-problema.',
  },
  'H2.16': {
    codigo: 'H2.16' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Representar',
    descricao:
      'Representar a relação de dependência entre medidas de duas grandezas em uma situação-problema.',
  },
  'H2.17': {
    codigo: 'H2.17' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar conceitos e/ou medidas de área/perímetro de polígonos, círculos e/ou suas partes na resolução de uma situação-problema.',
  },
  'H2.18': {
    codigo: 'H2.18' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar propostas ou interpretações baseadas em medidas de comprimento e/ou de área de polígonos, círculos e/ou suas partes em uma situação-problema.',
  },
  'H2.19': {
    codigo: 'H2.19' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar efeitos produzidos em uma situação-problema, mediante a alteração de medidas de grandezas associadas a polígonos, círculos e/ou suas partes nela presentes.',
  },
  'H2.20': {
    codigo: 'H2.20' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o Princípio Aditivo e/ou o Princípio Multiplicativo na contagem de permutações e/ou agrupamentos distintos (ordenáveis ou não) na resolução de uma situação-problema.',
  },
  'H2.21': {
    codigo: 'H2.21' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o conceito de probabilidade de ocorrência de eventos simples, compostos, sucessivos e/ou situados condicionalmente, associados a experimentos aleatórios, em espaços amostrais discretos, na resolução de uma situação-problema.',
  },
  'H2.22': {
    codigo: 'H2.22' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar a composição de um conjunto finito associado a uma situação-problema, de modo a viabilizar a existência de uma quantidade pré-determinada de agrupamentos distintos de seus elementos.',
  },
  'H2.23': {
    codigo: 'H2.23' as SkillMeta['codigo'],
    ano: 2 as SkillMeta['ano'],
    competencia: 5 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar parâmetros de uma situação-problema, de modo a tornar a ocorrência de eventos associados a experimentos aleatórios, em espaços amostrais discretos, mais, menos, ou igualmente prováveis.',
  },
  'H3.1': {
    codigo: 'H3.1' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder ângulos côngruos, ângulos com a mesma redução ao 1º quadrante ou ângulos a seus respectivos senos, cossenos e/ou tangentes em uma situação-problema.',
  },
  'H3.2': {
    codigo: 'H3.2' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar relações entre ângulos no círculo trigonométrico e seus senos, cossenos e/ou tangentes na resolução de uma situação-problema.',
  },
  'H3.3': {
    codigo: 'H3.3' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 1 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Analisar',
    descricao:
      'Analisar relações entre ângulos que compartilham o mesmo seno, cosseno e/ou tangente em uma situação-problema.',
  },
  'H3.4': {
    codigo: 'H3.4' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder um algoritmo, processo ou procedimento a seu fluxograma em uma situação-problema.',
  },
  'H3.5': {
    codigo: 'H3.5' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Representar',
    descricao:
      'Representar algebricamente ou graficamente relações entre variáveis numéricas/angulares em uma situação-problema.',
  },
  'H3.6': {
    codigo: 'H3.6' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder as representações algébrica e gráfica de relações de dependência entre variáveis numéricas/angulares em uma situação-problema, modeláveis por funções trigonométricas.',
  },
  'H3.7': {
    codigo: 'H3.7' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder pontos/retas/circunferências no plano cartesiano a suas coordenadas/equações algébricas em uma situação-problema (*).',
  },
  'H3.8': {
    codigo: 'H3.8' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Executar',
    descricao:
      'Executar etapas de um algoritmo representado em um fluxograma na resolução de uma situação-problema.',
  },
  'H3.9': {
    codigo: 'H3.9' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao: 'Utilizar equações trigonométricas na resolução de uma situação-problema.',
  },
  'H3.10': {
    codigo: 'H3.10' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar o conceito de função trigonométrica, suas diferentes formas de representação e/ou suas propriedades variacionais na resolução de uma situação-problema.',
  },
  'H3.11': {
    codigo: 'H3.11' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar relações entre pontos/retas/ circunferências no plano cartesiano e suas coordenadas/equações algébricas na resolução de uma situação-problema (*).',
  },
  'H3.12': {
    codigo: 'H3.12' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar etapas de um algoritmo e/ou do seu fluxograma, de modo a torná-lo apto a produzir resultados pré-determinados para uma situação-problema.',
  },
  'H3.13': {
    codigo: 'H3.13' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar características de uma situação-problema, a partir de propriedades da função trigonométrica que a modela.',
  },
  'H3.14': {
    codigo: 'H3.14' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar os parâmetros da função trigonométrica que modela uma situação-problema, a fim de que esta assuma características pré-determinadas.',
  },
  'H3.15': {
    codigo: 'H3.15' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 2 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar a disposição de pontos/retas/circunferências no plano cartesiano, a partir de suas coordenadas/equações algébricas em uma situação-problema (*).',
  },
  'H3.16': {
    codigo: 'H3.16' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Relacionar',
    descricao:
      'Relacionar elementos de poliedros, cilindros, cones e/ou esferas em uma situação-problema, a partir de suas propriedades geométricas.',
  },
  'H3.17': {
    codigo: 'H3.17' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder poliedros, cilindros, cones, esferas e/ou sólidos compostos a partir destes a suas planificações ou vistas em uma situação-problema.',
  },
  'H3.18': {
    codigo: 'H3.18' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Compreender',
    descricao:
      'Compreender o efeito de transformações isométricas ou homotéticas sobre uma figura geométrica plana em uma situação-problema.',
  },
  'H3.19': {
    codigo: 'H3.19' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar propriedades geométricas de poliedros, cilindros, cones e/ou esferas, suas planificações e/ou vistas na resolução de uma situação-problema.',
  },
  'H3.20': {
    codigo: 'H3.20' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar transformações isométricas e/ou homotéticas no plano na resolução de uma situação-problema.',
  },
  'H3.21': {
    codigo: 'H3.21' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar efeitos produzidos em uma situação-problema, mediante a alteração de elementos de poliedros, cilindros, cones e/ou esferas nela presentes.',
  },
  'H3.22': {
    codigo: 'H3.22' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 3 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar parâmetros de transformações isométricas e/ou homotéticas no plano em uma situação-problema, a fim de que esta assuma características pré-determinadas.',
  },
  'H3.23': {
    codigo: 'H3.23' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Corresponder',
    descricao:
      'Corresponder grandezas que são definidas como razão/produto entre grandezas a suas unidades de medida em uma situação-problema.',
  },
  'H3.24': {
    codigo: 'H3.24' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Comparar',
    descricao:
      'Comparar grandezas associadas a figuras planas e/ou sólidos geométricos em uma situação-problema.',
  },
  'H3.25': {
    codigo: 'H3.25' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar grandezas que são definidas como razão/produto entre grandezas, suas unidades de medida e/ou conversões entre elas na resolução de uma situação-problema.',
  },
  'H3.26': {
    codigo: 'H3.26' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar a Lei dos Senos e/ou a Lei dos Cossenos na resolução de uma situação-problema.',
  },
  'H3.27': {
    codigo: 'H3.27' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar grandezas associadas a figuras planas, sólidos geométricos e/ou suas relações na resolução de uma situação-problema.',
  },
  'H3.28': {
    codigo: 'H3.28' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 4 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar conclusões, interpretações ou propostas, a partir de medidas de grandezas associadas a figuras planas e/ou sólidos geométricos, ou que são definidas como razão/produto entre grandezas, em uma situação-problema.',
  },
  'H3.29': {
    codigo: 'H3.29' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'I' as SkillMeta['eixo'],
    verbo: 'Interpretar',
    descricao:
      'Interpretar dados apresentados em diferentes tipos de diagramas, gráficos estatísticos e/ou infográficos em uma situação-problema.',
  },
  'H3.30': {
    codigo: 'H3.30' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar dados apresentados em diferentes tipos de diagramas, gráficos estatísticos e/ou infográficos na resolução de uma situação-problema.',
  },
  'H3.31': {
    codigo: 'H3.31' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'II' as SkillMeta['eixo'],
    verbo: 'Utilizar',
    descricao:
      'Utilizar conceitos/medidas de tendência central e/ou dispersão de um conjunto de dados na resolução de uma situação-problema.',
  },
  'H3.32': {
    codigo: 'H3.32' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Avaliar',
    descricao:
      'Avaliar conclusões, interpretações ou comunicações mediadas por dados apresentados em diferentes tipos de diagramas, gráficos estatísticos e/ou infográficos em uma situação-problema.',
  },
  'H3.33': {
    codigo: 'H3.33' as SkillMeta['codigo'],
    ano: 3 as SkillMeta['ano'],
    competencia: 6 as SkillMeta['competencia'],
    eixo: 'III' as SkillMeta['eixo'],
    verbo: 'Modificar',
    descricao:
      'Modificar dados de uma distribuição de frequência em uma situação-problema, a fim de que esta assuma características de tendência central e/ou de dispersão pré-determinadas.',
  },
});

export const SKILL_CODES: readonly MatrixSkill[] = Object.keys(SKILLS) as MatrixSkill[];
